import { httpPost } from './Rest';

/**
 * Fetches the first account data from the work queue.
 *
 * @param {Object} data - The request payload containing necessary parameters for the API call.
 * @return {Promise<Object>} - A promise that resolves to the account data if the status is 200.
 */
export const getFirstAccountData = (data) => {
  return httpPost(`workqueue/execution/get/first/workqueue/account`, data)
    .then((data) => {
      if (data && data.status && data.status === 200) {
        return data;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

/**
 * Fetches the last account data from the work queue.
 *
 * @param {Object} data - The request payload containing necessary parameters for the API call.
 * @return {Promise<Object>} - A promise that resolves to the account data if the status is 200.
 */
export const getLastAccountData = (data) => {
  return httpPost(`workqueue/execution/get/last/workqueue/account`, data)
    .then((data) => {
      if (data && data.status && data.status === 200) {
        return data.response;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};
